<template>
	<div class="editor">
		<Editor v-model="editorValue" :init="init" :disabled="disabled"></Editor>
	</div>	
</template>

<script>
import tinymce from "tinymce/tinymce";
import Editor from "@tinymce/tinymce-vue";
import "tinymce/skins/ui/oxide/skin.min.css";
import "tinymce/themes/silver";
import "tinymce/icons/default/icons.js";
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/lists';
import "tinymce/plugins/image";
import "tinymce/plugins/link";
import 'tinymce/plugins/table';

import heic2any from 'heic2any';

const FILE_TYPE = ['image/jpeg','image/png','image/heic','image/heic-sequence','application/pdf'];

export default {
	name: 'RichText',
	props: {
		value: {
			type: String,
			default: ""
		},
		baseUrl: {
			type: String,
			default: ""
		},
		disabled: {
			type: Boolean,
			default: false
		},
		toolbar: {
			type: [String, Array],
			default: ''
		},
		plugins:  {
			type: [String, Array],
			default: ''
		},
		height: {
			type: Number,
			default: 500
		},
		width: {
			type: Number,
			default: 0
		}
	},
	data() {
		this.file_type = FILE_TYPE;

		return {
			init: {
				height: this.height,
				menubar: false,
				statusbar: false,
				branding: false,
				skin: "oxide",
				plugins: this.plugins,
				toolbar: this.toolbar,
				advlist_number_styles: 'default,lower-alpha,upper-alpha',
				table_toolbar: "",
				link_title: false,
				width: this.width !== 0 ? this.width : 'auto',

				image_description: false,
				automatic_uploads: true,
				file_picker_types: 'image',
				/** custom image picker */
				file_picker_callback: (callback) => {
					const input = document.createElement('input');
					input.setAttribute('type', 'file');
					input.setAttribute('accept', this.file_type.join(','));

					input.addEventListener('change', (e) => {
						const reader = new FileReader();

						const file = e.target.files[0];
						
						if (file.type === 'image/heic' || file.type === 'image/heic-sequence') {
							heic2any({ blob: file, toType: 'image/jpeg' }).then((blob) => {
								reader.addEventListener('load', () => {
									const id = 'blobid' + (new Date()).getTime();
									const blobCache = tinymce.activeEditor.editorUpload.blobCache;
									const base64 = reader.result.split(',')[1];
									const blobInfo = blobCache.create(id, blob, base64);
									blobCache.add(blobInfo);

									/* call the callback and populate the Title field with the file name */
									callback(blobInfo.blobUri(), { title: file.name });
								});
								reader.readAsDataURL(blob);

							}).catch((e) => {
								console.log(e.message)
							});
						} else {
							reader.addEventListener('load', () => {
								const id = 'blobid' + (new Date()).getTime();
								const blobCache =  tinymce.activeEditor.editorUpload.blobCache;
								const base64 = reader.result.split(',')[1];
								const blobInfo = blobCache.create(id, file, base64);
								blobCache.add(blobInfo);

								/* call the callback and populate the Title field with the file name */
								callback(blobInfo.blobUri(), { title: file.name });
							});
							reader.readAsDataURL(file);
						}						
					});

					input.click();
				},

				/** Registers a new menu button, only inserttable and deletetable  */
				setup: function (editor) {
					editor.ui.registry.addMenuButton('inserttable', {
						icon: 'table',
						fetch: (callback) => {
							const items = ['inserttable', 'deletetable'];
							callback(items);
						}
					});
				}
			},
			editorValue: this.value
		}
	},
	components: {
		Editor
	},
	watch: {
		value(newValue) {
			this.editorValue = newValue;
		},
		editorValue(newValue) {
			this.$emit("input", newValue);
		}
	},
}
</script>

<style scoped></style>
